// extracted by mini-css-extract-plugin
export var askAiIcon = "_lw-j";
export var category = "_lw-9";
export var categoryHeader = "_lw-e";
export var container = "_lw-0";
export var group = "_lw-a";
export var groupItems = "_lw-f";
export var groupSeparator = "_lw-k";
export var loading = "_lw-1";
export var noResults = "_lw-3";
export var placeholder = "_lw-2";
export var resultContent = "_lw-5";
export var resultIcon = "_lw-c";
export var resultItem = "_lw-g";
export var resultMeta = "_lw-8";
export var resultSubtitle = "_lw-7";
export var resultSuffix = "_lw-i";
export var resultTitle = "_lw-6";
export var resultsList = "_lw-4";
export var searchGroup = "_lw-d";
export var selected = "_lw-h";
export var subgroup = "_lw-b";